import React from "react";

import Loader from "../Loader/Loader";

function VacancyLoader() {
  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Loader minHeight="90vh" />
    </div>
  );
}

export default VacancyLoader;
